import { accountService } from '../common/services/accountService';
import {
  MUTATION_REGISTRATION_USERS,
  MUTATION_REGISTRATION_EMAIL,
  MUTATION_QUERY_PARAMETERS,
  MUTATION_REGISTRATION_FULLNAME,
  MUTATION_REGISTRATION_USERID
} from './constants';

export const loginStore = {
  state: {
    registrationEmail: null,
    registrationUserId: null,
    registrationUserFullName: null,
    returnUrl: null,
    registrationUsers: []
  },
  actions: {
    loadRegistrationUsers({ commit }, email) {
      return new Promise((resolve, reject) => {
        accountService
          .getSingleSignOnAccounts(email)
          .then((response) => {
            if (response.data) {
              if (
                response.data.companies != null &&
                response.data.companies.length > 0
              ) {
                const resultUsers = response.data.companies.flatMap((item) =>
                  item.users.map((item) => {
                    return {
                      userId: item.userId,
                      userPrivilegeCode: item.userPrivilegeCode,
                      firstName: item.firstName,
                      lastName: item.lastName,
                      fullName: `${item.firstName} ${item.lastName}`
                    };
                  })
                );
                commit(MUTATION_REGISTRATION_USERS, resultUsers);
              }
            }
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  mutations: {
    [MUTATION_REGISTRATION_EMAIL](state, email) {
      state.registrationEmail = email;
    },

    [MUTATION_QUERY_PARAMETERS](state, url) {
      state.returnUrl = url;
    },

    [MUTATION_REGISTRATION_USERS](state, users) {
      state.registrationUsers = users;
    },

    [MUTATION_REGISTRATION_FULLNAME](state, fullName) {
      state.registrationUserFullName = fullName;
    },
    [MUTATION_REGISTRATION_USERID](state, userId) {
      state.registrationUserId = userId;
    }
  },
  getters: {
    registrationUsers: (state) => {
      return state.registrationUsers;
    },
    registrationEmail: (state) => {
      return state.registrationEmail;
    },
    registrationUserFullName: (state) => {
      return state.registrationUserFullName;
    },
    registrationUserId: (state) => {
      return state.registrationUserId;
    }
  }
};
